import { isValidElement, ReactElement } from 'react';

import type { StepProps } from './components/Step/Step.types';

export const isStepComponent = (element: ReactElement): element is ReactElement<StepProps> => isValidElement(element);
